enum RolloutSampleStatus {
    PENDING = 'PENDING',
    START = 'START',
    SUCCESS = 'SUCCESS',
    ERROR = 'ERROR',
    CANCELLED = 'CANCELLED',
}

export default RolloutSampleStatus;
